import React, { useEffect, useState } from "react";
import axios from "axios";
import BASE_URL from "../config";
import "bootstrap/dist/css/bootstrap.min.css";
const AssignSubjects = () => {
  const [courses, setCourses] = useState([]);
  const [classes, setClasses] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState("");
  const [selectedClass, setSelectedClass] = useState("");
  const [selectedSubjectIDs, setSelectedSubjectIDs] = useState([]);
  const [assignedSubjects, setAssignedSubjects] = useState([]);
  const [staffs, setStaffs] = useState([]);
const [selectedStaff, setSelectedStaff] = useState("");
const [sections,setSections]=useState([]);
const [selectedSection,setSelectedSection]=useState("");
const [showSection, setShowSection] = useState(false);
  useEffect(() => {
    fetchInitialData();
  }, []);
  useEffect(() => {
    if (selectedCourse) {
      fetchClassesByCourse(selectedCourse);
    } else {
      setClasses([]);
      setSelectedClass("");
    }
  }, [selectedCourse]);
  useEffect(() => {
    if (selectedCourse && selectedClass) {
      fetchAssignedSubjects();
    } else {
      setAssignedSubjects([]);
    }
  }, [selectedCourse, selectedClass]);
  const fetchInitialData = async () => {
    try {
      const [courseRes, subjectRes, staffRes] = await Promise.all([
        axios.get(`${BASE_URL}/api/subjectClassCourse/getcourse`),
        axios.get(`${BASE_URL}/api/subjects`),
         axios.get(`${BASE_URL}/api/subjectClassCourse/getstaff`)
      ]);
      setCourses(courseRes.data);
      setSubjects(subjectRes.data);
      setStaffs(staffRes.data);
    } catch (err) {
      console.error("Error fetching initial data", err);
    }
  };
  const fetchClassesByCourse = async (courseId) => {
    try {
      const res = await axios.get(`${BASE_URL}/api/classes?course=${courseId}`);
      setClasses(res.data);
      setSelectedClass("");
    } catch (err) {
      console.error("Error fetching classes", err);
    }
  };
  const fetchAssignedSubjects = async () => {
    try {
        debugger;
      const res = await axios.get(`${BASE_URL}/api/subjectClassCourse`);
      const filtered = res.data.filter(
        (item) =>
          item.CourseID === parseInt(selectedCourse) &&
          item.ClassID === parseInt(selectedClass)
      );
      setAssignedSubjects(filtered);
    } catch (err) {
      console.error("Error fetching assigned subjects", err);
    }
  };
  const handleCheckboxChange = (id) => {
    setSelectedSubjectIDs((prev) =>
      prev.includes(id) ? prev.filter((sid) => sid !== id) : [...prev, id]
    );
  };
  const handleAssignSubjects = async () => {
    /*  if(!selectedStaff)
    {
        alert("Please select staff.");
        return;
    } */
    try {
      for (const subjectID of selectedSubjectIDs) {
         const existing = assignedSubjects.find(x =>
        Number(x.SubjectID) === Number(subjectID) &&
        Number(x.CourseID) === Number(selectedCourse) &&
        Number(x.ClassID) === Number(selectedClass) &&
        (
            (showSection
                ? Number(x.SectionID)
                : null)
            ===
            (showSection
                ? Number(selectedSection)
                : null)
        )
    );
 const payload = {
        StaffRegID: selectedStaff || null,
        SubjectID: Number(subjectID),
        ClassID:  Number(selectedClass),
        //SectionID: showSection ? selectedSection : null,
         /* SectionID:
        showSection && selectedSection !== ""
            ? Number(selectedSection)
            : null, */

            SectionID:
showSection && Number(selectedSection) > 0
    ? Number(selectedSection)
    : null,

        CourseID: Number(selectedCourse)
    };
/*          if (existing) {
        await axios.put(
            `${BASE_URL}/api/subjectClassCourse/${existing.AssignmentID}`,
            payload
        );
    } else {
        await axios.post(
            `${BASE_URL}/api/subjectClassCourse`,
            payload
        );
    } */
   if (!existing) {

    await axios.post(
        `${BASE_URL}/api/subjectClassCourse`,
        payload
    );

}
else if (existing.AssignmentID) {

    await axios.put(
        `${BASE_URL}/api/subjectClassCourse/${existing.AssignmentID}`,
        payload
    );

}
else {

    await axios.post(
        `${BASE_URL}/api/subjectClassCourse/assignStaff`,
        payload
    );

}
      }
      alert("Subjects assigned successfully.");
      setSelectedSubjectIDs([]);
      fetchAssignedSubjects();
    } catch (err) {
       console.log(err);
        alert(
            err.response?.data?.message ||
            "Error assigning subjects."
        );
    }
  };
const handleDeleteMapping = async (item) => {
   if (!window.confirm("Are you sure you want to remove this assignment?"))
        return;
       try {
        console.log(item);

     const res = await axios.delete(`${BASE_URL}/api/subjectClassCourse`, {
        data: {
            CourseID: item.CourseID,
            ClassID: item.ClassID,
            SectionID: item.SectionID,
            SubjectID: item.SubjectID
        }
    });
alert(res.data.message);   // Success message
    fetchAssignedSubjects();
     } 
     catch (err) {
    console.log(err);
    console.log(err.response?.data);
    alert(err.response?.data?.error || "Unable to delete.");
}
};
const handleClassChange = async (classID) => {
  setSelectedClass(classID);
  // Reset section
  setSelectedSection("");
  setSections([]);
  setShowSection(false);
  if (!classID) return;
  try {
    const res = await axios.get(
      `${BASE_URL}/api/sections/${classID}`
    );
    if (res.data.length > 0) {
      setSections(res.data);
      setShowSection(true);
    } else {
      setShowSection(false);
    }
  } catch (err) {
    console.error(err);
    setShowSection(false);
  }
};
  return (
    <div className="container mt-4">
      <h3>Assign Subjects to Course and Class</h3>
      <div className="row mb-3">
        <div className="col-md-4">
          <label>Course</label>
          <select
            className="form-select"
            value={selectedCourse}
            onChange={(e) => setSelectedCourse(e.target.value)}
            required
          >
            <option value="">Select Course</option>
            {courses.map((course) => (
              <option key={course.CourseID} value={course.CourseID}>
                {course.CourseName}
              </option>
            ))}
          </select>
        </div>
        <div className="col-md-4">
    <label>Staff</label>
    <select
        className="form-select"
        value={selectedStaff}
        onChange={(e)=>setSelectedStaff(e.target.value)}
    >
        <option value="">Select Staff</option>
        {
            staffs.map((staff)=>(
                <option
                    key={staff.Reg_Id}
                    value={staff.Reg_Id}
                >
                    {staff.FullName}
                </option>
            ))
        }
    </select>
</div>
        <div className="col-md-4">
          <label>Class</label>
          <select
            className="form-select"
            value={selectedClass}
            onChange={(e)=>handleClassChange(e.target.value)}
            disabled={!selectedCourse}
            required
          >
            <option value="">Select Class</option>
            {classes.map((cls) => (
              <option key={cls.id} value={cls.id}>
                {cls.name}
              </option>
            ))}
          </select>
        </div>
        {
showSection && (
 <div className="col-md-4">
          <label>Section</label>
          <select
value={selectedSection}
onChange={(e)=>setSelectedSection(e.target.value)}
>
<option value="">All Sections</option>
{sections.map(s=>
<option
key={s.SectionID}
value={s.SectionID}
>
{s.SectionName}
</option>
)}
</select>
  </div>
)
}
      </div>
      <h5>Select Subjects</h5>
      <div className="row">
        {subjects.map((subj) => (
          <div className="col-md-3" key={subj.SubjectID}>
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                value={subj.SubjectID}
                checked={selectedSubjectIDs.includes(subj.SubjectID)}
                onChange={() => handleCheckboxChange(subj.SubjectID)}
              />
              <label className="form-check-label">{subj.SubjectName}</label>
            </div>
          </div>
        ))}
      </div>
      <button
        className="btn btn-success mt-3"
        onClick={handleAssignSubjects}
        /* disabled={!selectedCourse || !selectedClass || (showSection && !selectedSection) ||  !selectedStaff || selectedSubjectIDs.length === 0} */
        disabled={!selectedCourse || !selectedClass || selectedSubjectIDs.length === 0}
      >
        Assign Selected Subjects
      </button>
      <hr />
      <h5>Assigned Subjects</h5>
      <table className="table table-bordered">
        <thead>
          <tr>
            <th>Staff</th>
            <th>Subject</th>
            <th>Course</th>
            <th>Class</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {assignedSubjects.map((item) => (
            <tr key={item.ID}>
              <td>{item.FullName || "Not Assigned"}</td>
              <td>{item.SubjectName}</td>
              <td>{item.CourseName}</td>
              <td>{item.ClassName}</td>
              <td>
                <button
                  className="btn btn-danger btn-sm"
                 /*  onClick={() => handleDeleteMapping(item.ID)} */
                  onClick={() => handleDeleteMapping(item)}
                >
                  Remove
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
export default AssignSubjects;
